<template>
    <div id="container-status" class="container-status" @click="showOptions()">
      <div class="statusCell" v-for="(option, index) in selectedElements" :key="index" v-show="selectedElements.includes(option)">
        <span v-if="typeSelector == 'relatedOrders'">{{ option.name }}</span>
        <span v-else>{{ option }}</span>
        <mdicon class="del-option-icon" title="Удалить" name="close" width="11" height="11" @click="delOption(option)"/> 
      </div>
    </div>
    <div :class="getClass()">
      <div class="option-row" v-for="(option, index) in options" :key="index" @click="editSelectedElement(option)">
        <input 
          type="checkbox"  
          :value="option"
          v-model="selectedElements"
        >
        <div v-if="typeSelector == 'relatedOrders'">
          {{ option.name }}
        </div>
        <div v-else>
          {{ option }}
        </div>
        
      </div>
    </div>
    <mdicon 
      id="select-status-down-field-icon" 
      class="down-field-icon" 
      name="chevron-down" 
      width="18" 
      height="18" 
      @click="showOptions()"
    /> 
  </template>
  
  <script>
  export default {
    name: 'SelectComponent',

    emits: [
      'selectedElements'
    ],

    props: {
      options: {
        type: Array,
        default: () => []
      },
      selected: {
        type: [Array, String, Number, Object],
        default: () => []
      },
      selectedType: {
        type: String,
        default: ''
      },
      defaultFields: {
        type: [Boolean, String],
        default: false
      },
      typeSelector: {
        type: String,
        default: ""
      },
      clearSelected: {
        default: false
      }
    },

    data() {
      return {
        showOptionsBlock: false,
        selectedElements: [],
        selectedTypeDuble: "",
      };
    },

    created() {
      if(this.selectedTypeDuble != "") {
        if(this.selectedTypeDuble != this.selectedType) {
          this.selectedElements = []
          this.selectedTypeDuble = this.selectedType
        }
      }
      
      // скрыть/показать абсолютный блок с выбором полей при клике за его пределы
      window.addEventListener('click', (e) => {
        let blocks = document.getElementsByClassName("select-option-block")
        for(let block of blocks) {
          if (block) {
            let styles = window.getComputedStyle(block)
            let displayValue = styles.getPropertyValue('display')
            if(displayValue == 'block' && e.target.id != 'container-status' && !block.contains(e.target)) {
              this.showOptionsBlock  = false
            }
          }
        }
      })
    },

    // Отслеживаем и передаем для записи изменения массива статусов при выборе/отмене 
    // Для отслеживания мутаций массива в V3 надо добавлять опцию deep
    watch: {
      selectedElements: {
        handler(val) {
          this.$emit('selectedElements', val)
        },
        deep: true
      },
      defaultFields: {
        handler() {
          this.selectedElements = []
        },
        deep: true,
      },
      clearSelected: {
        handler(val) {
          if(val) {
            this.selectedElements = this.selectedElements.filter(item => item.carId != val);
          }
        },
        deep: true,
      }
    },

    mounted() {
      if(this.selected != undefined && this.selected != null && this.selected != "")
        this.selectedElements = this.selected
    },

    methods: {
      showOptions() {
        if(this.showOptionsBlock) 
          this.showOptionsBlock = false
        else 
          this.showOptionsBlock = true 
      },

      getClass() {
        if(this.showOptionsBlock) 
          return 'select-option-block show'
        else
          return 'select-option-block'
      },

      editSelectedElement(index) {
        if (typeof this.selectedElements === 'string' || typeof this.selectedElements === 'number') {
          this.selectedElements = [];
        }
        console.log(this.selectedElements)

        if(this.selectedElements.includes(index)) {
          this.hideOption(index)
          // delete this.headersFilter[index];
        }
        else
          this.selectedElements.push(index)
      },

      delOption(index) {
        this.hideOption(index)
      },

      hideOption(index) {
        this.selectedElements = this.selectedElements.filter(function(element) {
          return element !== index;
        });
      },
    }

  };
  </script>